import type { HTMLAttributes, ReactNode } from "react";
import { classNames } from "./classNames";

interface CardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function Card({ className, children, ...props }: CardProps) {
  return <section className={classNames("rounded-2xl border border-slate-200 bg-white p-6 shadow-sm", className)} {...props}>{children}</section>;
}

export function CardHeader({ className, children, ...props }: CardProps) {
  return <header className={classNames("mb-5", className)} {...props}>{children}</header>;
}

export function CardTitle({ className, children, ...props }: CardProps) {
  return <h2 className={classNames("text-2xl font-semibold text-slate-950", className)} {...props}>{children}</h2>;
}

export function CardBody({ className, children, ...props }: CardProps) {
  return <div className={classNames("text-slate-600", className)} {...props}>{children}</div>;
}
